import { useEffect } from "react";
import { useDispatch } from "react-redux";
import "./hero-section-tech.css";
import { useHistory } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";

const HeroSectionTech = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => { }, [dispatch]);

  const handleBannerClick = () => {
    history.push("/group/66644c6e84ea229fc8ee4ec9");
  };

  const handleBannerClick2 = () => {
    history.push("/group/66644f0f3b181ed7d8251e10");
  };

  return (
    <section className="hero-area">
      <div className="container">
        <div className="row">
          {/* LEFT SLIDER */}
          <div className="col-lg-8 col-12 custom-padding-right">
            <div className="slider-head">
              <div className="hero-slider">
                <Carousel
                  autoPlay={true}
                  infiniteLoop={true}
                  showIndicators={false}
                  showThumbs={false}
                  onClickItem={(index) => {
                    if (index === 0) handleBannerClick();
                    if (index === 1) history.push("/group/66644f0f3b181ed7d8251df6");
                  }}
                >
                  {/* Slider 1 */}
                  <div
                    className="single-slider"
                    style={{
                      backgroundImage: `url(${window.location.origin}/images/agro_simple_banner.png)`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      cursor: "pointer",
                      position: "relative",
                      zIndex: 1
                    }}
                    onClick={() => handleBannerClick()}
                  >
                    {/* <div className="content">
                      <h2>
                        <span>No restocking fee ($35 savings)</span>
                        M75 Sport Watch
                      </h2>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur elit, sed do
                        eiusmod tempor incididunt ut labore dolore magna aliqua.
                      </p>
                      <h3>
                        <span>Now Only</span> $320.99
                      </h3>
                      <div className="button">
                        <a href="product-grids.html" className="btn">
                          Shop Now
                        </a>
                      </div>
                    </div> */}
                  </div>

                  {/* Slider 2 */}
                  <div
                    className="single-slider"
                    style={{
                      backgroundImage: `url(${window.location.origin}/images/start-saving.png)`,
                      cursor: "pointer",
                      position: "relative",
                      zIndex: 1
                    }}
                    onClick={() => history.push("/group/66644f0f3b181ed7d8251df6")}
                  >
                    {/* <div className="content">
                      <h2>
                        <span>Big Sale Offer</span>
                        Get the Best Deal on CCTV Camera
                      </h2>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur elit, sed do
                        eiusmod tempor incididunt ut labore dolore magna aliqua.
                      </p>
                      <h3>
                        <span>Combo Only:</span> $590.00
                      </h3>
                      <div className="button">
                        <a href="product-grids.html" className="btn">
                          Shop Now
                        </a>
                      </div>
                    </div> */}
                  </div>
                </Carousel>
              </div>
            </div>
          </div>

          {/* RIGHT BANNERS */}
          <div className="col-lg-4 col-12">
            <div className="row">
              {/* Small Banner 1 */}
              <div className="col-lg-12 col-md-6 col-12 md-custom-padding">
                <div
                  className="hero-small-banner"
                  onClick={handleBannerClick2}
                  style={{
                    backgroundImage: `url(${window.location.origin}/images/big_moves.png)`,
                    cursor: "pointer"
                  }}
                >
                </div>
              </div>

              {/* Small Banner 2 */}
              <div className="col-lg-12 col-md-6 col-12">
                <div
                  className="hero-small-banner style2"
                  onClick={handleBannerClick}
                  style={{
                    backgroundImage: `url(${window.location.origin}/images/banner1.jpg)`,
                    cursor: "pointer"
                  }}
                >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSectionTech;
